import Axios from 'axios'
import Vue from 'vue'

import BaseRefObject from "./helpers/baseRefObject"
import FormatRefObject from "./helpers/formatRefObject"
import { stateMerge } from "vue-object-merge"

const RefStore = {
    namespaced: true,
    state: {
        savenRefs: [],
        savenCats: [],
        customRefs: [],
        customCats: [],
        currentRef: {},
        formValidity: [],
        formCurrentStep: 0,
        formStepsName: [],
        currentCatId: -1,
        sort_column: 'name',
        sort_type: 'asc',
        currentPage: 1,
        totalPages: 0,
        itemPerPage: 0,
        searchQuery: null
    },
    getters: {
        searchRefs: (state) => (query) =>{
            if(query != ""){
                return state.customRefs.filter(ref => {
                    return ref.name.toLowerCase().includes( query.toLowerCase() )
                });
            }else{
                return []
            }

        }
    },
    mutations: {
        getRefs(state, indexData){
            if(indexData.refType == 'saven'){ state.savenRefs = indexData.refList }
            if(indexData.refType == 'custom'){ state.customRefs = indexData.refList }
        },
        getCats(state, indexData){
            if(indexData.refType == 'saven'){ state.savenCats = indexData.catList }
            if(indexData.refType == 'custom'){ state.customCats = indexData.catList }
        },
        initNew(state){
            state.currentRef = BaseRefObject()
            state.formValidity = [false, false, false, false]
            state.formStepsName = ["FormStep1", "FormStep2", "FormStep3", "FormStep4", "FormStep5"]
            state.formCurrentStep = 0
        },
        updateRefData(state, refData){
            stateMerge(state.currentRef, refData)
        },
        updateFormValidity(state, validityData){
            Vue.set(state.formValidity, validityData.index, validityData.validity)
        },
        changeCurrentStep(state, formData){
            state.formCurrentStep = formData.index
        },
        initEdit(state, currentRef){
            state.currentRef = currentRef
            state.formValidity = [true, true, true, true]
            state.formStepsName = ["FormStep1", "FormStep2", "FormStep3", "FormStep4"]
            state.formCurrentStep = 0
        },
        IndexCustomRef(state, resp){
            if (resp.meta){
                state.currentCatId = resp.meta.ref_cat_id
                state.totalPages = resp.meta.total_pages
                state.currentPage = resp.meta.current_page
                state.itemPerPage = resp.meta.item_per_page
                state.searchQuery = resp.meta.search_query
                state.sortColumn = resp.meta.sort_column
                state.sortType = resp.meta.sort_type
            }
            state.customRefs = resp.sight_refs
        }
    },
    actions: {
        indexRefs: indexRefs,
        indexCats: indexCats,
        initNew: initNew,
        createRef: createRef,
        initEdit: initEdit,
        saveRef: saveRef,
        createCat: createCat,
        deleteCat: deleteCat,
        deleteRef: deleteRef,
        duplicateRef: duplicateRef,
        createFriendRefs: createFriendRefs,
        CustomRefsList: CustomRefsList
    }
}

function CustomRefsList(context, params){
    const data = {
        ref_cat_id: params.cat_id ? params.cat_id : context.state.currentCatId,
        sort_column: params.sort_column ? params.sort_column : context.state.sort_column,
        sort_type: params.sort_type ? params.sort_type : context.state.sort_type,
        page: params.page ? params.page : context.state.currentPage,
        search_query: (params.search_query != null) ? params.search_query : context.state.searchQuery
    }
    Axios.get(this.sharpApiBaseUrl + "sight_refs/custom_refs_list", {params: data} )
    .then(resp => {
        context.commit('IndexCustomRef', resp.data)
    })
    .catch(err => {
        console.log("RefsStore/Index error", err)
    })
}


function createFriendRefs(context, friendRef){
    return Axios.post(this.sharpApiBaseUrl + "sight_ref_friends/", {friend_refs: friendRef} ).then(resp => {
        return resp
    }).catch(err => {
        console.log("RefsStore/Delete ref error", err.response)
    })
}


function duplicateRef(context, ref){
    return Axios.post(this.sharpApiBaseUrl + "sight_refs/" + ref.id + "/duplicate" ).then(resp => {
        return resp
    }).catch(err => {
        console.log("RefsStore/Delete ref error", err.response)
    })
}

function deleteRef(context, ref){
    return Axios.delete(this.sharpApiBaseUrl + "sight_refs/" + ref.id, ).then(resp => {
        return resp
    }).catch(err => {
        console.log("RefsStore/Delete ref error", err.response)
    })
}

function deleteCat(context, cat){
    return Axios.delete(this.sharpApiBaseUrl + "sight_ref_cats/" + cat.id, ).then(resp => {
        return resp

    }).catch(err => {
        console.log("RefsStore/Delete cat error", err.response)
    })
}

function createCat(context, catName){
    Axios.post(this.sharpApiBaseUrl + "sight_ref_cats", {sight_ref_cat: {name: catName}}).then(resp => {
        this.dispatch('RefStore/indexCats', "custom")

    }).catch(err => {
        console.log("RefsStore/Index error", err.response)
    })
}

function saveRef(context, currentRef){
    const formatedRef = FormatRefObject(currentRef)
    return Axios.put(this.sharpApiBaseUrl + "sight_refs/" + formatedRef.id, {sight_ref: formatedRef}).then(resp => {
        return resp
    }).catch(err => {
        console.log("RefsStore/Index error", err.response)
    })
}

function initEdit(context, refId){
    Axios.get(`${this.sharpApiBaseUrl}sight_refs/${refId}/edit`).then(resp => {
        console.log(resp.data)
        context.commit('initEdit', resp.data)
    }).catch(err => {
        console.log("RefsStore/Index error", err)
    })
}

function createRef(context, currentRef){
    const formatedRef = FormatRefObject(currentRef)
    Axios.post(this.sharpApiBaseUrl + "sight_refs", {sight_ref: formatedRef}).then(resp => {
        context.commit('updateRefData', resp.data)
    }).catch(err => {
        console.log("RefsStore/Index error", err.response)
    })
}

function initNew(context){
    context.commit('initNew')
}

function indexCats(context, refType){
    Axios.get(this.sharpApiBaseUrl + "sight_ref_cats", { params: {ref_cat_type: refType} } )
    .then(resp => {
        context.commit('getCats', {catList: resp.data, refType: refType})
    })
    .catch(err => {
        console.log("RefsStore/Index error", err)
    })
}

function indexRefs(context, refType){
    Axios.get(this.sharpApiBaseUrl + "sight_refs", { params: {ref_type: refType} } )
    .then(resp => {
        context.commit('getRefs', {refList: resp.data, refType: refType})
    })
    .catch(err => {
        console.log("RefsStore/Index error", err)
    })
}


export default RefStore